export class PlantPalletRequest{
    plantId: number;
    palletId: string;
    constructor(plantId: number,palletId:string){
        this.plantId = plantId
        this.palletId = palletId
    }
}